import { Project } from '.';
import { Rights } from '@shared/enums';
import { FileUpload } from './file-upload.model';

export interface Subproject {
  id: number;
  name: string;
  scopeName: string;
  vesselLocationName: string;
  project: Project;
  isLocked: boolean;
  isReleased: boolean;
  dprScreen?: Rights;
  fileUpload?: FileUpload;
  projectSetup?: Rights;
  canExportData: boolean;
  canDownloadDprFiles: boolean;
  canEditExternalPartyComment: boolean;
  canApprove: boolean;
  canAccessHiddenComments: boolean;
}
